import { __extends } from "tslib";
import { ValueObject } from '../../../../../base/ddd-types/value-object';
import { officialType } from './official-info.interface';
var OfficialInfoObjectValue = /** @class */ (function (_super) {
    __extends(OfficialInfoObjectValue, _super);
    function OfficialInfoObjectValue(jsonObj) {
        var _this = _super.call(this) || this;
        /**
         * ValueObject的属性必须在这里初始化了， 才能正确的使用equals和jsonObj方法
         */
        _this.avatar = '';
        _this.nick = '';
        _this.introduction = '';
        _this.type = 0;
        _this.principal = '';
        _this.credential = '';
        _this.isOfficialAccount = false;
        if (jsonObj) {
            _this.setOfficialAccountStatus(jsonObj);
            _this.jsonObj2Class(jsonObj);
        }
        return _this;
    }
    /**
     * 判断账号是否是测试账号。
     * kinga 发现实际上部分企业和事业单位实际上没有 credential 字段和，和微信认证文档不一致。
     * 这里改成用 type 来判断，测试同学测试的时候需要伪造认证的 user_info
     */
    OfficialInfoObjectValue.prototype.setOfficialAccountStatus = function (jsonObj) {
        this.isOfficialAccount = jsonObj.type !== officialType.UNAUTHED;
    };
    return OfficialInfoObjectValue;
}(ValueObject));
export { OfficialInfoObjectValue };
